import { Component, Input, Output, EventEmitter } from '@angular/core';
import { WindowMessagesService } from '@app/services/window-messages.service';
/**
 * @description Component
 * @class AgErrorComponent
 */
@Component({
  standalone: false,
  selector: 'app-ag-error',
  templateUrl: './ag-error.component.html',
})
export class AgErrorComponent {
  @Input() errorTitle = '';
  @Input() errorDescription = '';
  @Input() buttonText = '';
  @Input() noCancelButton = false;
  @Output() buttonClick: EventEmitter<any> = new EventEmitter();

  /**
   * @description Creates an instance of AgErrorComponent.
   * @param _windowMessagesService WindowMessagesService
   */
  constructor(
    private readonly _windowMessagesService: WindowMessagesService
  ) { }

  /**
   * @description emitEvent
   */
  emitEvent(): void {
    this.buttonClick.emit();
  }

  /**
   * @description exit
   */
  exit(): void {
    this._windowMessagesService.error();
  }
}
